import type { InsertionSide } from './types';

export type InsertionLineProps = {
  visible: boolean;
  side: InsertionSide;
  className?: string;
};

/**
 * Visual insertion indicator shown while dragging items between rows.
 */
export function InsertionLine({
  visible,
  side,
  className = '',
}: InsertionLineProps): JSX.Element | null {
  if (!visible) return null;

  return (
    <div
      role="separator"
      aria-hidden
      data-side={side}
      data-dnd-insertion-line="true"
      className={`h-[2px] w-full bg-white/90 ${className}`}
    />
  );
}
